const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const MPPaymentOnDeliveryCommissionCommand: any = {
    DeleteCodCommissionRanges: Backofficebff + '/v1/CodCommissionRange/delete-cod-commission-range',
    UpsertCodCommissionRange: Backofficebff + '/v1/codcommissionrange/upsert-cod-commission-range',
    InsertBulkCodCommissionRangesExcel: Backofficebff + '/v1/codcommissionrange/insert-bulk-cod-commission-range',
};
